<script>
import Day from '@/components/atoms/Day'
import InputSelect from '@/components/atoms/inputlib/components/InputSelect'
import { mapGetters } from 'vuex'

export default {
    name: 'DaySelector',
    components: { Day, InputSelect },
    props: {
        value: null,
        days: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            innerStyles: {},
            step: null,
            block: 1,
            maxBlock: 1,
            daysCountInOneBlock: 5,
        }
    },
    computed: {
        ...mapGetters(['smDevice', 'locale']),
        daysSelect() {
            return this.days.filter((day) => !day.disabled)
        },
    },
    mounted() {
        const activeIndex = this.days.findIndex((day) => day?.isSame(this.value, 'day'))
        if (activeIndex > -1) {
            this.block = Math.floor((activeIndex + 1) / this.daysCountInOneBlock)
            this.nextWeek()
        }
        this.maxBlock = Math.ceil(this.$refs.dayWrapper.children.length / this.daysCountInOneBlock)
    },
    methods: {
        nextWeek() {
            if (!this.step)
                this.step =
                    (this.$refs.dayWrapper?.scrollWidth / this.$refs.dayWrapper.children.length) *
                    this.daysCountInOneBlock
            this.innerStyles = {
                transform: `translateX(-${this.step * this.block}px)`,
            }
            this.block++
        },
        prevWeek() {
            if (!this.step)
                this.step =
                    (this.$refs.dayWrapper?.scrollWidth / this.$refs.dayWrapper.children.length) *
                    this.daysCountInOneBlock
            this.block--
            this.innerStyles = {
                transform: `translateX(-${this.step * (this.block - 1)}px)`,
            }
        },
        setDay(day) {
            if (!this.disabled)
                this.$emit(
                    'input',
                    this.$moment(this.value)
                        .set({
                            year: day.year(),
                            date: day.date(),
                            month: day.month(),
                        })
                        .valueOf()
                )
        },
    },
}
</script>

<template lang="pug">
.day-selector-wrapper
    template(v-if="smDevice")
        input-select.w-100(
            :value="value"
            :options="daysSelect"
            :disabled="!days.length"
            :key="`day-${daysSelect.length || 0}`"
            :custom-label="date => $options.filters.toSelectDay(date, locale)"
            @input="setDay"
            no-empty)
    template(v-else)
        button.btn.btn-secondary.btn-icon(@click="prevWeek" :disabled="block === 1")
            icon(icon="fa-solid fa-angle-left")
        .day-wrapper(ref="dayWrapper" :style="innerStyles")
            day(
                v-for="day in days"
                :value="value"
                :day="day"
                :key="`day-${$options.filters.toDate(day)}`"
                :disabled="day.disabled"
                :style="{width: `${100 / daysCountInOneBlock}%`}"
                @input="setDay")
        button.btn.btn-secondary.btn-icon(@click="nextWeek" :disabled="block === maxBlock")
            icon(icon="fa-solid fa-angle-right")
</template>
